import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useCurrentUser } from "hooks/useCurrentUser";
import { useFeatureFlags } from "hooks/useFeatureFlags";

/**
 * Whether the reader gets the bell. Staff always do, with or without an
 * organization open, as the flag's staff override promises; everyone else follows
 * their organization's flag.
 */
export function useNotificationsEnabled(): boolean {
  const { featureFlags } = useFeatureFlags();
  const { isStaff } = useCurrentUser();
  return isStaff || featureFlags[FeatureFlagKey.Notifications];
}
